import React, { useState } from 'react';
import { Alert, AlertIcon } from '@chakra-ui/react';
import getTechLibraryFileUrl from '../../utils/tech-library-file-url';

// Plays a Firebase-hosted video straight from its URL. Unlike TechLibraryFiles, this does not pre-fetch the file to check for errors,
// which would download the whole video before playback could start. The browser streams it with range requests instead.
const TechLibraryVideoPlayer = ({ url }) => {
  const [hasError, setHasError] = useState(false);

  if (hasError) {
    return (
      <Alert status="error" className="m-8">
        <AlertIcon />
        Sorry for any inconvenience. This video could not be loaded. Please contact support so we can help you fix this issue.
      </Alert>
    );
  }

  return (
    <div className="flex items-center w-full" style={{ minHeight: 'calc(100vh - 64px)', backgroundColor: 'black' }}>
      <video
        key={url}
        src={getTechLibraryFileUrl(url)}
        controls
        autoPlay
        preload="auto"
        onError={() => setHasError(true)}
        style={{ width: '100%', maxHeight: 'calc(100vh - 64px)' }}
      />
    </div>
  );
};

export default TechLibraryVideoPlayer;
